import { HOME_ROUTE } from '@/config/constant';
const state = {
	tags: JSON.parse(localStorage.getItem('tags'))
		? JSON.parse(localStorage.getItem('tags'))
		: [HOME_ROUTE],
	tag: JSON.parse(localStorage.getItem('tag'))
		? JSON.parse(localStorage.getItem('tag'))
		: { path: '/home' },
	lang: localStorage.getItem('lang') || 'zh_CN',
	downloads: [],
	errors: [],
	query: {},
	isDownloaded: true // 下载任务是否都完成
};
export default state;
